import { render, staticRenderFns } from "./BLoading.vue?vue&type=template&id=532ea3de&scoped=true&"
import script from "./BLoading.vue?vue&type=script&lang=js&"
export * from "./BLoading.vue?vue&type=script&lang=js&"
import style0 from "./BLoading.vue?vue&type=style&index=0&id=532ea3de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ea3de",
  null
  
)

export default component.exports